import CryptoJS from "crypto-js";
import { SM4 } from "gm-crypto";
import "./CryptoJSEx";

/**
 * @description IGS二进制流解密函数
 * @param {Object} options
 * @param {ArrayBuffer} [options.arrayBuffer] 加密的二进制流
 * @param {String} [options.key] 秘钥，要求传入base64编码的字符串
 * @param {String} [options.algorithm] 加密的算法，目前仅支持 'AES'、'SM4'
 * @param {String} [options.iv] 初始化向量，要求传入base64编码的字符串
 * @param {String} [options.secretMsg] 二次加密的key和iv值
 * @return {ArrayBuffer} 解密后的二进制流
 */
function decryptIGS(options) {
  options = options || {};
  let { key, iv, algorithm, arrayBuffer, secretMsg } = options;
  let result;
  if (!(arrayBuffer instanceof ArrayBuffer)) {
    throw new Error("加密文件格式传入错误，请传入ArrayBuffer对象");
  }
  
  if (!secretMsg && !key) {
    throw new Error("缺少解析秘钥");
  }

  if(!key){
    const encoder = new TextEncoder()
    const keyWord = CryptoJS.enc.u8array.parse(encoder.encode("313233343536373a"));
    const secretData = CryptoJS.AES.decrypt(secretMsg, keyWord, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
      
    const decodeText = CryptoJS.enc.Utf8.stringify(secretData)
    if (!decodeText || decodeText === "null:null") {
      throw new Error("解密失败");
    }

    key = decodeText.split(':')[0]
    iv = decodeText.split(":")[1];
  }

  switch (algorithm) {
    case "AES":
    case "AES/CTR":
      if (!iv) {
        iv = "knOzAaK1xRcPrNPvG583DQ==";
      }
      iv = CryptoJS.enc.Base64.parse(iv);
      key = CryptoJS.enc.Base64.parse(key);
      // decrypt接口第一个参数必须传入base64编码的字符串
      const base64Str = CryptoJS.enc.Base64.stringify(
        CryptoJS.enc.u8array.parse(new Int8Array(arrayBuffer))
      );
      result = CryptoJS.AES.decrypt(base64Str, key, {
        iv,
        mode: CryptoJS.mode.CTR,
        padding: CryptoJS.pad.NoPadding,
      });

      // debug base64
      // const base64 = CryptoJS.enc.Base64.stringify(result);
      result = CryptoJS.enc.u8array.stringify(result);
      break;
    case "SM4":
    case "SM4/CBC":
      if (!iv) {
        iv = "xRtXf8aGB63ZXc1K8LOBfQ==";
      }
      // 接口此处要求转为16进制的字符串
      const ivHex = CryptoJS.enc.Hex.stringify(CryptoJS.enc.Base64.parse(iv));
      const keyHex = CryptoJS.enc.Hex.stringify(CryptoJS.enc.Base64.parse(key));
      result = SM4.decrypt(arrayBuffer, keyHex, {
        iv: ivHex,
        mode: SM4.constants.CBC,
        padding: "none",
      });
      break;
    default:
      throw new Error(`未定义的加密的算法，请检查名称为${algorithm}的加密算法`);
      break;
  }

  return result;
}

export default decryptIGS;
